export default {
    site: {
        common: {
            hello: "Olá",
            thankYou: "Obrigado",
            forMoreInfo: "Para mais informação",
            hoverOverColumnHeaders: "Coloque o rato em cima do cabeçalho das colunas para mais informação.",
            username: "Utilizador",
            score: "Pontuação",
            points: "Points",
            pointsAbbreviation: "pts",
            chapter: "Capitulo",
            tier: "Tier",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Recolhas por dia",
            relicBoostPercent: "Relíquias Boost %",
            mountainHallPercentShort: "Salões da Montanha %", // used in table heading keep it short.
            updated: "actualizado",
            lastUpdated: "nova actualização",
            created: "criado",
            role: "estatuto",
            Fellow: 'Membro',
            Ambassador: 'Embaixador',
            Mage: 'Mago',
            Archmage: 'Arquimago',
            saveChanges: "Guardar alterações",
            copy: "Copiar",
            close: "Fechar",
            cancel: "Cancelar",
            action: "Acção",
            date: "Data",
            Left: "à esquerda",
            Joined: "Entrada",
            human: "Humano",
            elf: "Elfo",
            search: "Procura",
            enter: "Enter",
            yes: "Sim",
            no: "Não",
            tournament: "Torneio",
            tournaments: "Torneios",
            fellowship: "Irmandade",
            player: "Jogador",
            member: "Membro",
            history: "História",
            tournamentHistory:  "Histórico do torneio",
            scoreHistory: "Histórico da pontuação",
            server: "Servidor",
            lastWeekGain: "Ganho na última semana",
            comingSoon: "Em breve",
            chest: "Báu",
            yourServer: "Seu servidor",
            allServers: "Todos os servidores",
            boosts: "Bonificações",
            marble: "mármore",
            steel: "aço",
            planks: "tábuas",
            crystal: "cristal",
            scrolls: "pergaminhos",
            silk: "seda",
            elixir: "elixir",
            magic_dust: "pó mágico",
            gems: "gemas",
            sentient: "Elementais",
            goods: "mercadorias",
            average: "média",
            expansions: 'Expansões', // 5x5 grids
            cultureBoostMinimum: 'Bonificação de Cultura (Min)',
            cultureBoostCalculated: 'Bonificação de cultura calculada',
            neighborlyHelp: 'Ajuda da vizinhança',
            neighborlyHelpAbbreviation: 'AV'
        },
        // HIGH PRIORITY
        nav: {
            home: "Inicio",
            players: "Jogadores",
            fellowships: "Irmandades",
            tournaments: "Torneios",
            contact: "Contacto",
            donate: "Doações",
            faq: "FAQ",
            news: "Novidades",
            privacyPolicy: "Política de Privacidade",
            me: "Eu",
            myFellowship: "Minha Irmandade",

            // NOTE USED AT THE MOMENT
            globalStats: "Estatísticas Globais",
            articles: "Artigos",
            fellowshipAdventure: "Fellowship Adventures",
            recruit: "Recrutar",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Ver cidade no ElvenArchitect"
            ,obtainingLink: "Obtenção de endereço"
            ,successMessage: "Sucesso! Clique no endereço abaixo para ir para o Elven Architect"
            ,ageOfLink: "O link acima irá mostrar a cidade como ela é: "
            ,clickToGetCurrentCity: "<-- Clique para carregar a cidade actual",
        },
        // High Priority
        playerSelection: {
            headline: "Ver site como",
            description: "Isto irá actualizar varias partes do site que estão customizadas para o seu perfil no site. Exemplos incluídos: A minha Irmandade, Meu Perfil, Torneios e paginas de classificação. ",
            youAreViewing: "Está agora a ver o site como {username} no {serverName}.",
            changeUser: "Mudar Perfil",
            enterYourUsernameToGetStarted: "Insira o seu nome de jogador para iniciar",
            thisIsNotASignup:"Isto não é um processo de registro . Ao introduzir o seu perfil, nós simplesmente customizamos o site adequadamente. Existem muitos servidores de Elvenar e nós iremos mostrar os resultados de classificação para o seu servidor. Além disso, os links para a sua irmandade e a sua pagina pagina de perfil irão ficar disponiveis. "
        },
        searchBoxes: {
            enterFellowshipName: 'Introduza o nome da sua Irmandade Enter Fellowship Name',
            instructions: "Escreva o nome e selecione um.",
            noFellowship: "Sem Irmandade",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dias atrás",
            minsAgo: "minutos atrás",
            hoursAgo: "horas atrás",
            justNow: "neste momento",
            never: "Nunca",
        },
        home: {
            welcome: "Bem vindo a Elven Stats!",
            youAreViewing: "Está agora a ver o site como {username} on {serverName}",
            youCanChange: "Pode mudar o user ao clickar no avatar no canto superior direito -ou- através de <router-link to='/contact'>visitando esta pagina</router-link>",
            features: {
                headline: "Características",
                fellowshipAdministration: {
                    headline: "Administração da Irmandade <strong>MADE EASY</strong>",
                    bullet1: "Monitoramento Automatico das mercadorias bonificadas para o ajudar a balancear melhor a sua irmandade",
                    bullet2: "Monitoramento Automatico/geração de e-mails de relatórios semanais incluindo pontos, participação no torneio , crescimento mensal e motivação \"Elogios\" e recordes pessoais",
                    bullet3: "Help identify your fellow members production imbalances such as supplies or incorrect ratio of tiers",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Integration</strong>",
                    description: "Load your city exactly as it is into ElvenArchitect in seconds! Use this to better plan your next big city reorganization or to find space you didn't realize you had! Look for the ElvenArchitect logo on the player pages."
                },
                advancedRankingLists: {
                    headline: "Advanced <strong>Ranking Lists</strong>",
                    bullet1: "Ranking List by Unlocked Areas (to compare yourself against people at same stage)",
                    bullet2: "View Boosts, Chapter Number, and more in Player lists.",
                },
                fellowshipTournamentTracking: {
                    headline: "Fellowship Tournament <strong>Tracking</strong>",
                    description: "See how your fellowship stacks up against others. Challenge other fellowships to a dual for a friendly competition!",
                },
                matchMaking: {
                    headline: "Match <strong>Making</strong>",
                    description: "ElvenStats tracks players boosts and the goods production ratios of fellowships.  With this information, fellowships can recruit the right candidates to balance their goods. Users looking for a fellowship can find fellowships that actually NEED their boosts. Saving time and reducing rejection!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rank",
                points: "Points",
                medianUserScore: "Median <strong>User Score</strong>",
                memberCount: "Member <strong>Count</strong>",
            },
            barCharts: {
                clickSlice: "Click a slice for details (by member)",
                tier1: "Tier 1",
                tier2: "Tier 2",
                tier3: "Tier 3",
                drillDown: "Back To {0}"
            },
            idealCandidate: {
                heading: "Ideal Candidate",
                description: "Would have a score around {medianScore} and would have one or more of the following boosts: {boosts}",
                note: "Some combinations of boosts are not possible. See {0}"
            },
            memberGoodsTable: {
                heading: "Members Good Production",
                description: `This table computes how much of each good your fellowship makes. We took an educated guess as to what your
                respective members boost percentages were and by default we're assuming each member does 3 collections per day
                (2x9h and 1x3h). To improve the accuracy, ask your fellowship members what their actual values are and enter them below. You can
                save what you enter so it will show up next time you load this page. The bar charts above will update automatically after you make changes. Hover over the column
                headers for more information about a particular column.'
                `,
                refreshButtonText: 'Refresh Member List',
                refreshButtonTip: 'This will add new members, remove old members, update fellowship roles, and update current scores.',
                inactiveWarningTip: 'User may be inactive, Score Last Updated: {0}',
                collectsPerDayValidation: "Must be between 1-6",
                boostPercentValidation: "Must be between 40 - 700, do not include bonus from mountain halls",
                perDayShort: "/day",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "The players score, please note this is not updated in realtime.  It's updated several times a week.",
                chapterTip: "This is the chapter each player is in.  For reference: Elementals = 12, Halflings = 11, etc.",
                boostTip: "The Players Boost and the amount PRODUCED per day.",
                collectsPerDayTip: `***EDITABLE*** <br/>Collects Per Day. This is the number of times per day the user collects goods from their manufacturies. It should be a value from 1 - 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Please see the FAQ for more.`,
                relicBoostPercentTip: `***EDITABLE***<br/>The boost percent from relics, it's between 40-700.  It should not include the players Mountain Hall Percent.  That is detected automatically and added to this number`,
                mountainHallPercentTip: "This is the Mountain Hall Boost Percentage we detected for this user.  It is used in conjunction with the boost %'s to calculate total boost percent.",
                updatedTip: "This is the when the players city was last analyzed.  This process is what sets the boosts, elven architect data, calculates production from all manufactories, mountain hall %, and more. City map data is periodically fetched automatically but you can force an update below by clicking the refresh button.",

            },
            coinsAndSuppliesTable: {
                heading: "Coins / Supplies Production",
                description: `The key column here is "Supplies Left" as it indicates whether a member will produce enough supplies to keep their
                manufactories producing 24/7.  Use the toggle switches below to take into account the players minimum culture boost (which is the boost you'd have if you had no neighborly help)
                and/or the number of times the member collects per day (as specified in Goods Table above).  Turning both off is useful if you want to see how much of the supplies are attributed
                to more manufactories or a higher culture boost. Finally, please note that having low negative (~10% of total) number of supplies left is fairly common. There are many ways players
                supplement their supplies such as by visiting neighbors, producing supplies at faster intervals (Beverages, Simple Tools, Bread...) or using Power of Provision spells.
                Think of the negative value as what you'd need to make up on a daily basis by doing one of these options.
                NOTE: at the moment troop production is not taken into account in the supplies used (Only Tier 1, Tier 2, and Tier 3 goods) so you may need more.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min Boost %",
                made: "Made",
                used: "Used",
                left: "Left",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                moneyComputedTip: "The amount of coins produced in a day, includes any Ancient Wonders that produce coins",
                moneyUsedComputedTip: "The amount of coins consumed by producing goods.",
                moneyRemainingComputedTip: "Coins - Coins Used, it's the surplus or deficit in coins a player will have each day",
                suppliesComputedTip: "The number of supplies that would be produced if all workshops were set to 24x1 (Toolboxes) + any ancient wonders. (does not include set bonuses)",
                suppliesUsedComputedTip: "The number of supplies consumed by producing goods. DOES NOT include supplies used by your barracks! See explanation above.",
                suppliesRemainingComputedTip: "Supplies - Supplies Used, it's the surplus or deficit in supplies a player will have each day",
                manaTip: "The amount of Mana produced in 24 Hours (does not include Dragon Abbey)",
            },
            popCultureTable: {
                heading: "Population/Culture Details",
                description: 'The table below shows population/culture for each member. Hover over the column headers for more information.',

                // Icon Sub-Headings
                minBoostPercent: "Min Boost %",
                levels: "Levels",
                total: "Total",
                working: "Working",
                available: "Available",
                required: "Required",

                // Low Priority - Tool Tips
                wonderLevelsTip: "The total number of ancient wonder levels a player has.",
                cultureBoostPercentTip: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                totalPopulationTip: "Total Culture produced by residences, culture/population hybrid buildings and ancient wonders",
                workingPopulationTip: "Working Population - The amount consumed by buildings",
                availablePopulationTip: "Available Population",
                totalCultureTip: "Total Culture produced by culture buildings, culture/population hybrid buildings and ancient wonders",
                requiredCultureTip: "Required Culture needed for all your buildings",
                availableCultureTip: "Available Culture",
            },
            cityCoverageTable: {
                heading: "City Coverage",
                description: "Shows how many tiles are used in each members city for the particular building type. The empty tiles are tiles which are currently not being used.",
                tiles: 'Tiles'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Weekly Email Report",
                description: "We automatically generate weekly reports suitable for sharing with your fellowship members. A new weekly report will be available each Sunday (approximately around 8pm UTC) for the previous week. Simply copy the blurb below and paste!",
                selectReportHint: "Select Report for Week Ending On",
                reportsAreOptimizedFor: "Email reports are optimized for display in the Elvenar messaging system such that columns align as properly as possible and usernames are truncated so it'll fit in a single message.",
                accolades: "accolades",
                tourneyChamp: " - Tourney Champ (this week): {0}",
                tourneyHero: " - Tourney Hero (last 4 weeks): {0}",
                highestGrowthPlusPercentage: " - Highest Growth (points & percentage): {0}",
                highestGrowthPoints: " - Highest Growth (points): {0}",
                highestGrowthPercentage: " - Highest Growth (percentage): {0}",
                highestGrowthError: " - Highest Growth: Can't be determined yet, need more history",
                newPersonalRecords: "New Personal Records",
                userSetANewPersonalRecordFor: " * {0} set a new personal record for: {1}",
                allMembersByPointGainThisWeek: "ALL MEMBERS by Point Gain / Percent (this week)",
                tournamentPointsHeader: "TOURNAMENT Points (this week / TOTAL SINCE {0})",
                top8ByPercentage: "TOP 8 By Percentage (this week)",
                top8ByPointsSince: "TOP 8 By Points (Since {0})",
                top8ByPercentageSince: "TOP 8 By Percentage (Since {0})",
                reportGeneratedBy: "Report generated by elvenstats.com, for more see: ",
                mostPointsInAWeek: "Most Points In A Week",
                highestTournamentScore: "Highest Tournament Score",
                highestTournamentRank: "Highest Tournament Rank",
                insufficientHistoryForThesePlayers: "* Omitted: {0} due to insufficient history.  They will be included next week",
                insufficientHistory1Week: "* Insufficient History for this section. Check back next week!",
                insufficientHistory4Weeks: "* Insufficient History for this section. 4 weeks of history is needed. Check back soon!",
            },
            memberHistory: {
                heading: "Member History",
                noChangesDetected: "No member changes detected yet since fellowship tracking began on {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'You have unsaved changes. When finished editing your fellowship click the save button.',
                standbyImporting: 'Standby: We are importing some of your fellows that are missing information',
                limitedHistory: "We very recently began tracking this {0} so there is limited history.  Each Sunday, weekly snapshots will show up here so be sure to check back soon!",
                noChangesSinceTrackingBegan: "No Changes since tracking began",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Fellowship History"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Realtime updates are unavailable at this time.",
            realTimeUpdatesNotAvailableDescription: "This typically occurs after the Elvenar Game Servers are restarted to deploy an update or for maintenance. Once this occurs, ElvenStats must manually login to all game servers before information can be retrieved on demand.  Please try your request in a couple hours.  In the meantime, the site is fully functional otherwise.",
            copyToClipboardSuccessful: "Copy To Clipboard Successful!",
            copyToClipboardFailed: "Failed to copy, highlight the entire text area and then do CTRL+C",
            errorOccurredImporting: "Error Occurred. Importing your users.",
            errorOccurredImportingMessage: "An error occurred trying to import your users.  Please try again.  If the error, persists please contact us.",
            errorOccurredImportingWillNotBeAvailableInReports: "Users which have not been imported will not be included in the reports.",
            finishedSyncSuccessful: "Finished, Sync was successful!",
            playerIsAnonymous: "Player has requested their information not be displayed on elvenstats.com",
            inactiveWarningTip: "This player may be inactive.  Score last changed: {0}",
            isFriendTip: "This player is a friend to ElvenStats.  They've either contributed their time or money to support the site!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/pt.js